<div class="max-w-2xl mx-auto p-4 text-left">
  <h2 class="text-2xl font-bold text-green-600 mb-4">Thank You for Your Order!</h2>

  <div *ngIf="order">
    <h3 class="text-lg font-semibold mb-2">Customer Info</h3>
    <p><strong>Name:</strong> {{ order.customerName }}</p>
    <p><strong>Email:</strong> {{ order.customerEmail }}</p>
    <p><strong>Phone:</strong> {{ order.customerPhone }}</p>
    <p><strong>Address:</strong> {{ order.shippingAddress }}</p>

    <h3 class="text-lg font-semibold mt-6 mb-2">Order Summary</h3>
    <div *ngFor="let item of order.items" class="flex justify-between border-b py-1">
      <span>{{ item.product.name }} x {{ item.quantity }}</span>
      <span>{{ item.product.price * item.quantity | currency:'BDT' }}</span>
    </div>
    <div class="mt-2 font-bold text-right">Total: {{ order.totalAmount | currency:'BDT' }}</div>
  </div>
</div>

